import React from "react";
import HowItWorksItem from "./HowItWorksItem";
import { Link } from "react-router-dom";

const HowItWorks = () => {
  return (
    <>
      <section className="howitworks pt-180">
        <div className="container">
          <div className="row">
            <div className="col-xl-10 offset-xl-1 col-lg-10 offset-lg-1">
              <div className="section-title text-center pos-rel mb-75">
                <div className="section-icon">
                  <img
                    className="section-back-icon"
                    src="img/section/section-back-icon.png"
                    alt=""
                  />
                </div>
                <div className="section-text pos-rel">
                  <h5>How It Works</h5>
                  <h2>
                    Steps to get your medical forms completed at{" "}
                    <i>SouthVanMed.com</i>
                  </h2>
                </div>
                <div className="section-line pos-rel">
                  <img src="img/shape/section-title-line.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="row pos-rel d-flex justify-content-between">
            <HowItWorksItem
              icon="1"
              title="Upload Your Form"
              moveIcon="move-icon"
              description="Securely upload your form using our online request system."
            />
            <HowItWorksItem
              icon="2"
              title="Complete Questionnaire"
              moveIcon="move-icon"
              description="Fill out a short questionnaire about your request."
            />
            <HowItWorksItem
              icon="3"
              title="Payment"
              description="Pay the form completion fee."
            />

            <HowItWorksItem
              icon="4"
              title="Provider Review"
              description="A healthcare provider will review your chart and complete the form."
              moveIcon="move-icon"
            />

            <HowItWorksItem
              icon="5"
              title="Form Delivered"
              description="We'll email you the completed form."
              moveIcon="move-icon"
            />

            <HowItWorksItem
              icon="6"
              title="Use Your Form"
              description="Submit your completed form to the requesting organization."
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default HowItWorks;
